/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ accounts: NonNullable<unknown> }} Ledger_Error_Classification_ConflictInputs */

const en_ledger_error_classification_conflict = /** @type {(inputs: Ledger_Error_Classification_ConflictInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`These accounts changed since you opened them: ${i?.accounts}. Nothing was saved — reload the page and redo those rows.`)
};

const nl_ledger_error_classification_conflict = /** @type {(inputs: Ledger_Error_Classification_ConflictInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deze rekeningen zijn gewijzigd sinds u ze opende: ${i?.accounts}. Er is niets opgeslagen, herlaad de pagina en pas die regels opnieuw aan.`)
};

/**
* | output |
* | --- |
* | "These accounts changed since you opened them: {accounts}. Nothing was saved — reload the page and redo those rows." |
*
* @param {Ledger_Error_Classification_ConflictInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_classification_conflict = /** @type {((inputs: Ledger_Error_Classification_ConflictInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Classification_ConflictInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_classification_conflict(inputs)
	return en_ledger_error_classification_conflict(inputs)
});